/**
 * Seizoenen van het lopende seizoen terug tot `startYear`, nieuwste eerst
 * (bv. "2026-27", "2025-26", …). Een nieuw seizoen start op 1 juli.
 */
export function buildSeasonOptions(startYear = 1980, now: Date = new Date()): string[] {
  const y = now.getFullYear();
  const m = now.getMonth();
  const currentSeasonStart = m >= 6 ? y : y - 1;

  const seasons: string[] = [];
  for (let sy = currentSeasonStart; sy >= startYear; sy -= 1) {
    seasons.push(`${sy}-${(sy + 1).toString().slice(-2)}`);
  }
  return seasons;
}
